import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Use local images from public/pharmacy
const images = [
  { src: '/pharmacy/pharmacy1.jpg', caption: 'Pharmacy College 1' },
  { src: '/pharmacy/pharmacy2.jpg', caption: 'Pharmacy College 2' },
  { src: '/pharmacy/pharmacy3.jpg', caption: 'Pharmacy College 3' },
  { src: '/pharmacy/pharmacy4.jpg', caption: 'Pharmacy College 4' },
  { src: '/pharmacy/pharmacy5.jpg', caption: 'Pharmacy College 5' },
  { src: '/pharmacy/pharmacy6.jpg', caption: 'Pharmacy College 6' },
];

export default function PharmacySlideshowBackground() {
  const [current, setCurrent] = useState(0);
  const [imgError, setImgError] = useState<{ [key: number]: boolean }>({});

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const fallback = '/pharmacy/fallback.jpg';

  return (
    <div style={{ position: 'relative', width: '100%', height: '400px', overflow: 'hidden', background: '#222' }}>
      <AnimatePresence initial={false}>
        {images.map((img, idx) =>
          idx === current ? (
            <motion.img
              key={img.caption + '-' + idx}
              src={imgError[idx] ? fallback : img.src}
              alt={imgError[idx] ? 'Image not found' : img.caption}
              style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'relative', zIndex: 1 }}
              draggable={false}
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -100, opacity: 0 }}
              transition={{ duration: 0.8, ease: 'easeInOut' }}
              onError={() => setImgError((prev) => ({ ...prev, [idx]: true }))}
            />
          ) : null
        )}
      </AnimatePresence>
      {/* Overlay for darkening and readability */}
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.3)', pointerEvents: 'none' }} />
      {/* Caption overlay */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)', color: 'white', fontSize: '1.5rem', fontWeight: 600, padding: '1rem 1.5rem', zIndex: 2, userSelect: 'none', textShadow: '0 2px 8px #000' }}>
        {images[current].caption}
      </div>
    </div>
  );
}
